import React from 'react';
import ReactDOM from 'react-dom';
import { EmbeddedWidget } from './EmbeddedWidget';
window.__ET_VERSION = process.env.GITHUB_RUN_NUMBER + "-" + process.env.GITHUB_SHA;
var widgetRoot = document.getElementById('__EDDY_TRAVELS_CHAT_EMBED');
if (widgetRoot) {
    ReactDOM.render(React.createElement(EmbeddedWidget, null), widgetRoot);
    window.__ET_LOADED = true;
}
